import React, { useEffect, useMemo, useState } from "react";

import { FormattedMessage, IntlShape } from "react-intl";
import moment from "moment";
import DatePickerGroup from "../../../witadmin/CRUD/Common/DatePickerGroup";
import { messages } from "./messages";
import { Container, DatePickerContainer } from "./styles";
import "react-datepicker/dist/react-datepicker.css";
import "react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css";
import { ErrorFieldMessage } from "../ErrorFieldMessage";

export type RangeDateType = {
  startDate: string | null;
  endDate: string | null;
};

type OpenBookingProps = {
  field: Record<string, any>;
  intl: IntlShape;
  disabled: boolean;
  defaultValues: RangeDateType;
  onChange: (rangeDate: RangeDateType) => void;
};

export const OpenBooking = ({ field, disabled, defaultValues, onChange }: OpenBookingProps) => {
  const [rangeWindow, setRangeWindow] = useState<RangeDateType>(defaultValues);

  useEffect(() => setRangeWindow(defaultValues), [defaultValues]);

  const handleOnChangeStartDate = ({ value }: { value: string }) => {
    onChange({ ...rangeWindow, startDate: value });
    setRangeWindow({ ...rangeWindow, startDate: value });
  };

  const handleOnChangeEndDate = ({ value }: { value: string }) => {
    onChange({ ...rangeWindow, endDate: value });
    setRangeWindow({ ...rangeWindow, endDate: value });
  };

  const isInvalidForm = useMemo(() => {
    const isEndDateBeforeStartDate = moment(rangeWindow.endDate).isBefore(rangeWindow.startDate);
    return !disabled && rangeWindow && rangeWindow.endDate && isEndDateBeforeStartDate;
  }, [disabled, rangeWindow]);

  return (
    <Container>
      <DatePickerContainer>
        <FormattedMessage {...messages.startBookable} />
        <DatePickerGroup
          disabled={disabled}
          value={rangeWindow && rangeWindow.startDate}
          isClearable={false}
          field={{
            ...field,
            fieldName: "startDate",
            displayName: <FormattedMessage {...messages.startBookable} />,
            selectsStart: true,
          }}
          formValues={{
            startDate: rangeWindow && rangeWindow.startDate,
            endDate: rangeWindow && rangeWindow.endDate,
          }}
          onChange={handleOnChangeStartDate}
        />

        <>
          <FormattedMessage {...messages.endBookable} />
          <DatePickerGroup
            disabled={disabled}
            value={rangeWindow && rangeWindow.endDate}
            isClearable={false}
            field={{
              ...field,
              fieldName: "endDate",
              displayName: <FormattedMessage {...messages.endBookable} />,
              selectsEnd: true,
            }}
            formValues={{
              startDate: rangeWindow && rangeWindow.startDate,
              endDate: rangeWindow && rangeWindow.endDate,
            }}
            onChange={handleOnChangeEndDate}
          />
        </>
      </DatePickerContainer>
      {isInvalidForm && <ErrorFieldMessage {...messages.endDateAfterStart} />}
    </Container>
  );
};
